/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EMartialStatus } from "../types/EMartialStatus.ts";

/**
 * @description 0 = Uninformed | 1 = Married | 2 = Unmarried |
 */
export const eMartialStatusSchema = z
  .union([z.literal(0), z.literal(1), z.literal(2)])
  .describe(
    "0 = Uninformed | 1 = Married | 2 = Unmarried | ",
  ) as unknown as ToZod<EMartialStatus>;
